import React, {useState} from "react";
import Collapse from "@material-ui/core/Collapse";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import IconButton from "@material-ui/core/IconButton";
import PeopleRelatedTable from "./PeopleRelatedTable/PeopleRelatedTable";

function RelatedCard(props) {

    const {related_people} = props

    const [expanded, setExpanded] = useState(false);

    const handleExpand = (event) => {
        event.stopPropagation();
        setExpanded(!expanded);
    };
    return (
        <div className="analysisCard">
            <div style={{display:"flex"}}>
            <div 
                className={["blueText", "subtitleSize", "bold"].join(" ")}
                style={{margin:"auto 0px"}}
            >
                Pessoas Relacionadas
            </div>
            {related_people.data.length === 0 ? 
                <IconButton style={{marginLeft: "auto"}} onClick={handleExpand}>
                    {expanded ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                </IconButton>  
                : null           
                }                    
            </div>

            {related_people.data.length === 0 ? 
            <Collapse in={expanded} timeout="auto" unmountOnExit>
                <div className={["labelText", "normalMediumSize", "internalCardContainer"].join(" ")}
                        style={{textAlign: "center"}}>
                    Sem registro de pessoas relacionadas para o CPF
                </div>
            </Collapse> :
                <div className={["normalText", "normalMediumSize", "internalCardContainer"].join(" ")}>
                    <PeopleRelatedTable related_people_data={related_people.data}/>
                </div>
            }
        </div>
    );
}


export default RelatedCard